import './styles.css'

const PageTitle = ({title}) => {
    return(
        <h1 id="pageTitle">{title}</h1>
    )
}

export default PageTitle